import { FromBody, HttpStatusCodes, NotImplementedError, Result } from '@resourceful-hono/core';
import AuthResource from '../index.ts';
import type { z } from 'zod';
import type { RefreshTokenPayload } from '../../../../services/OAuth/types.ts';
import { POST_SCHEMA } from './schema.ts';
import { getTokenFromHeaders } from '../../../../common/utils.ts';

export class TokenResource extends AuthResource {
  public async POST(
    @FromBody(POST_SCHEMA) tokenRequest: z.infer<typeof POST_SCHEMA>
  ) {
    switch (tokenRequest.grant_type) {
      case 'authn_token': {
        const {
          sub: subject,
          jti: tokenCredentialId,
        } = await this.oAuth.verifyToken(tokenRequest.authn_token);
        const scope = tokenRequest.scope?.split(' ') ?? [];
        const accessTokenResponse = await this.oAuth.generateAccessToken(
          subject,
          Number(tokenCredentialId),
          scope
        );
        return Result(HttpStatusCodes.Ok, accessTokenResponse);
      }
      case 'refresh_token': {
        const {
          sub: subject,
          jti: tokenCredentialId,
          scp: originalScope,
        } = await this.oAuth.verifyToken(
          tokenRequest.refresh_token
        ) as RefreshTokenPayload;
        let scope = tokenRequest.scope?.split(' ') ?? originalScope;
        scope = scope.filter(scope => originalScope.includes(scope));
        const accessTokenResponse = await this.oAuth.generateAccessToken(
          subject,
          Number(tokenCredentialId),
          scope
        );
        return Result(HttpStatusCodes.Ok, accessTokenResponse);
      }
      default: {
        throw new NotImplementedError('Unsupported grant type');
      }
    }
  }

  public async DELETE() {
    const token = getTokenFromHeaders(this.request.headers);
    await this.oAuth.deleteTokenCredential(token);
    return Result(HttpStatusCodes.Ok);
  }
}